import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksSalesInvoiceForm.SalesInvoiceCustomerSection', {
    sectionTitle: 'Customer details',
    customerFieldTitle: 'Customer',
    customerPlaceholder: 'Select a Customer',
    billingAddressFieldTitle: 'Billing Address',
    billingAddressPlaceholder: 'Enter billing address',
    createCustomer: '+ New Customer',
});
